import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'
import OpalHeading from '../../opal/OpalHeading'
import OpalCard from '../../opal/OpalCard'
import Markup from '../../atoms/Markup'

function NoteDialogBody ({ item }) {
  const descriptionHtml = useMemo(() => {
    return item?.description || item?.content
  }, [item])

  const { formatter } = useFormattingContext()
  const activity = item

  if (!item) return null

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <OpalHeading className='font-size-md'>Created</OpalHeading>
        <div
          className='font-size-sm'
          style={{ fontWeight: '100' }}
        >{formatter(activity.createdDate, '&M/D/YY h:mm a')}
        </div>
      </Grid>
      {descriptionHtml ? (
        <Grid item xs={12}>
          <OpalHeading className='font-size-md'>Description</OpalHeading>
          <OpalCard size='md'>
            <Markup type='html' value={descriptionHtml} />
          </OpalCard>
        </Grid>
      ) : null}
    </Grid>
  )
}

NoteDialogBody.propTypes = {
  item: PropTypes.object
}

export default NoteDialogBody
